import { Injectable } from "@angular/core";
import { CanActivate, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { ContractedFeatureUtil } from "../utils/contracted-feature.utils";

@Injectable()
export class FeatureArrivalGuard implements CanActivate {
  constructor(
    private readonly contractedFeatureUtil: ContractedFeatureUtil
  ) { }

  canActivate():
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.contractedFeatureUtil.hasCheguei();
  }
}
